import { useSubscriptionEvent } from '@confluence/graphql/entry-points/useSubscriptionEvent.ts';
import { fg } from '@confluence/feature-gating';
import { StatsigConfigurations } from '@confluence/statsig-configurations/entry-points/StatsigConfigurations.ts';

type useContentRestrictionSubscriptionEventProps = {
	callback: (data?: any) => void;
	subscriberId: string;
	contentId: string;
	contentType: string;
};

export const useContentRestrictionSubscriptionEvent = ({
	callback,
	subscriberId,
	contentId,
	contentType,
}: useContentRestrictionSubscriptionEventProps): void => {
	useSubscriptionEvent({
		onDataReceived: callback,
		delta: 'contentRestrictionUpdated',
		subscriberId,
		contentType,
		contentId,
		skip:
			// eslint-disable-next-line confluence-feature-gating/no-preconditioning
			!fg('confluence_enable_subscriptions-context-provider') ||
			!['DUAL', 'GRAPHQL'].includes(
				StatsigConfigurations.getString('confluence-migrate-fps-to-graphql-subscription', ''),
			),
	});
};
